import { LogResponse } from '../../types';

type LogDetailsProps = {
    entry: LogResponse | null | undefined;
    isLoading: boolean;
};

const formatValue = (value: any) => {
    if (value === undefined || value === null) return '—';
    return JSON.stringify(value, null, 2);
};

export default function LogDetails({ entry, isLoading }: LogDetailsProps) {
    if (isLoading) {
        return <div className="activity-log__details-status">Loading details…</div>;
    }

    if (!entry) {
        return <div className="activity-log__details-status">Could not load the details of this entry.</div>;
    }

    return (
        <div className="activity-log__diff">
            <div>
                <p>Before</p>
                <pre>{formatValue(entry.lastValue)}</pre>
            </div>
            <div>
                <p>After</p>
                <pre>{formatValue(entry.newValue)}</pre>
            </div>
        </div>
    );
}
